import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Close, ScreenshotMonitor } from "@mui/icons-material";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectProcesses, setSelectedEmployee } from "../processSlices";
import { Employee, PhotoTypes } from "../types/processTypes";
import { EmployeeMediaCard } from "./EmployeeMediaCard";

type Props = {
  open: boolean;
  employee: Employee | null;
  onClose: () => void;
};

export function MusanedHeldScreenshotDialog({
  open,
  employee,
  onClose,
}: Props) {
  const dispatch = useAppDispatch();
  const { selectedEmployee } = useAppSelector(selectProcesses);

  useEffect(() => {
    if (open && employee) {
      dispatch(setSelectedEmployee(employee));
    }
  }, [open, employee, dispatch]);

  const current =
    selectedEmployee &&
    employee?._id &&
    String(selectedEmployee._id) === String(employee._id)
      ? selectedEmployee
      : employee;

  const src = current?.additionalData?.musanedHeldScreenshot;
  const employeeId = current?._id ? String(current._id) : undefined;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        <Stack spacing={0.25}>
          <Typography variant="h6" component="span">
            Musaned placement screenshot
          </Typography>
          {current && (
            <Typography variant="body2" color="text.secondary">
              {current.givenName} {current.surName}
            </Typography>
          )}
        </Stack>
        <IconButton aria-label="close" onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack alignItems="center" sx={{ py: 1 }}>
          <EmployeeMediaCard
            title="Musaned held screenshot"
            src={src}
            icon={<ScreenshotMonitor fontSize="small" />}
            uploadInputIdPrefix="musaned-held-screenshot"
            attachmentManage={
              employeeId
                ? {
                    employeeId,
                    photoType: PhotoTypes.MusanedHeldScreenshot,
                    enabled: true,
                    accept: "image/*",
                    suppressGlobalSuccess: true,
                  }
                : undefined
            }
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
